import { createQueryKeys } from '@lukemorales/query-key-factory';

import type { FetchConfigurablesArgs } from '../api/types/configurables.types';

import { fetchConfigurables } from '../api/configurables.api';

export const configurablesQueryKeys = createQueryKeys('configurables', {
  fetchConfigurables: ({ filters, isMandatory }: FetchConfigurablesArgs) => ({
    queryFn: () =>
      fetchConfigurables({
        filters,
        isMandatory,
      }),
    queryKey: [isMandatory, filters],
  }),
  fetchInfiniteConfigurables: ({
    filters,
    isMandatory,
  }: FetchConfigurablesArgs) => ({
    queryFn: (context) =>
      fetchConfigurables({
        filters: {
          ...filters,
          offset: (context?.pageParam as string) || '1',
          orderBy: filters?.orderBy || 'name',
        },
        isMandatory,
      }),
    queryKey: [isMandatory, filters],
  }),
});
